var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57969 18.4203 0.375 12 0.375C5.57969 0.375 0.375 5.57969 0.375 12C0.375 18.4203 5.57969 23.625 12 23.625Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3289 18.9281C20.2447 17.4765 18.8369 16.2979 17.2173 15.4858C15.5978 14.6737 13.8112 14.2506 11.9994 14.25C10.1877 14.2494 8.40076 14.6715 6.7807 15.4825C5.16065 16.2936 3.7521 17.4714 2.66699 18.9222C3.74658 20.3804 5.15283 21.5654 6.77298 22.3821C8.39314 23.1987 10.1821 23.6244 11.9965 23.625C13.8108 23.6256 15.6001 23.201 17.2207 22.3853C18.8414 21.5697 20.2484 20.3856 21.3289 18.9281Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C14.4853 12.75 16.5 10.7353 16.5 8.25C16.5 5.76472 14.4853 3.75 12 3.75C9.51472 3.75 7.5 5.76472 7.5 8.25C7.5 10.7353 9.51472 12.75 12 12.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.a3f05fe8de31e10079a4261b21245511.svg";
export { ForwardRef as ReactComponent };